export class InterviewResourceNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "Interview Resource Not Found!";
  }
}
